"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _arkReact = require("@dateam/ark-react");
const Spinner = _ref => {
  let {
    className
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("span", {
    className: (0, _arkReact.concatClassName)('loader-spinner', className)
  });
};
process.env.NODE_ENV !== "production" ? Spinner.propTypes = {
  className: _propTypes.default.string
} : void 0;
Spinner.defaultProps = {
  className: undefined
};
var _default = exports.default = Spinner;